




import Vue from 'vue';

import Utils from '@/Utils';
import axios from 'axios';

export default Vue.extend({
  methods: {
    downloadApplication() {
      const applicationId = (this as any).params.data.id;

      /*
        Create a new window and open it on click so it doesn't get blocked as a popup
      */
      const fileWindow = window.open('/loading.html', '_blank');

      axios
        .get(
          `${
            process.env.VUE_APP_API_URI
          }/api/admin/applications/export/${applicationId}`,
          {
            responseType: 'blob',
          }
        )
        .then(res => {
          if (res.status !== 200) {
            Utils.toastError('An error has occured. Try again later.');
            return;
          }

          const filename =
            res.headers['content-disposition'].split('"')[1] ||
            'application.pdf';

          const file = new File([res.data], filename, {
            type: res.data.type,
          });

          const url = URL.createObjectURL(file);
          if (fileWindow) {
            // Replace the opened window's url to display the document
            fileWindow.location.href = url;
            // fileWindow.name = filename;
          } else {
            window.open(url);
          }
        })
        .catch(err => {
          if (fileWindow) {
            fileWindow.close();
          }

          Utils.toastError(
            'An error occured while preparing the document. Please try again later.'
          );
        });
    },
  },
});
